// Regla de negocio: las visitas programadas solo pueden agendarse martes,
// jueves o viernes. `datetime-local` ya entrega la fecha en hora local del
// navegador, así que alcanza con `getDay()` (no hace falta offset de
// Argentina como en el backend, que recibe todo en UTC).
const DIAS_PERMITIDOS = [2, 4, 5]; // martes, jueves, viernes (0=domingo..6=sábado)

export const MENSAJE_DIA_NO_PERMITIDO =
  'Las visitas programadas solo se pueden agendar martes, jueves o viernes.';

export function esDiaPermitido(date: Date): boolean {
  return DIAS_PERMITIDOS.includes(date.getDay());
}
